import { render, staticRenderFns } from "./bGoodsManage.vue?vue&type=template&id=3702ac29&scoped=true"
import script from "./bGoodsManage.vue?vue&type=script&lang=js"
export * from "./bGoodsManage.vue?vue&type=script&lang=js"
import style0 from "./bGoodsManage.vue?vue&type=style&index=0&id=3702ac29&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3702ac29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3702ac29')) {
      api.createRecord('3702ac29', component.options)
    } else {
      api.reload('3702ac29', component.options)
    }
    module.hot.accept("./bGoodsManage.vue?vue&type=template&id=3702ac29&scoped=true", function () {
      api.rerender('3702ac29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_homeCloudPlatform/mall/bGoodsManage.vue"
export default component.exports